"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* eslint-disable max-len */
/* eslint-disable quotes, indent */
var _default = {
  "inputForm.instruction": "Alle velden zijn verplicht, tenzij gemarkeerd als optioneel",
  "inputField.label.firstName": "Voornaam",
  "inputField.label.lastName": "Achternaam",
  "inputField.label.fullName": "Naam op kaart",
  "inputField.label.Email": "E-mail",
  "inputField.label.phoneNumber": "Telefoonnummer",
  "inputField.placeholder.firstName": "John",
  "inputField.placeholder.lastName": "Doe",
  "inputField.placeholder.fullName": "John Doe",
  "inputField.errorMessage.pleaseEnterAValidFirstName": "Voer een geldige voornaam in",
  "inputField.errorMessage.pleaseEnterAValidLastName": "Geef alstublieft een geldige achternaam",
  "inputField.errorMessage.pleaseEnterAValidFullName": "Voer een geldige volledige naam in",
  "inputField.errorMessage.invalidAddressValue": "Vul alstublieft een geldig adres in",
  "inputField.errorMessage.invalidCityValue": "Voer een geldige stad in",
  "inputField.placeholder.email": "john.doe@bhn.com",
  "inputField.placeholder.phoneNumber": "Voer telefoonnummer in",
  "inputField.errorMessage.incompleteField": "Onvolledig veld",
  "inputField.errorMessage.exceedsMaxCharacters": "Overschrijdt {max} tekens",
  "inputField.errorMessage.pleaseEnterAValidEmailAddress": "Voer een geldig e-mailadres in",
  "inputField.errorMessage.pleaseEnterAValidPhoneNumber": "Voer een geldig telefoonnummer in",
  "inputField.errorMessage.invalidName": "Vul alstublieft een geldige naam in",
  "header.text.billingInfo": "Factuurgegevens",
  "submitButton.adyen.label": "Nu betalen",
  "inputField.label.saveCardLabel": "Bewaar voor later",
  "inputField.label.makeAsDefaultLabel": "Markeren als standaard",
  "paymentMethod.paypal.login.initial": "Om het afrekenen via PayPal te voltooien, logt u in en valideert u de betalingsgegevens",
  "paymentMethod.paypal.login.success": "Validatie geslaagd, voltooi de kassa",
  "paymentMethod.adyen.label": "Credit card and E-banking",
  "paymentMethod.adyen.single.label": "Credit card",
  "paymentMethod.paypal.label": "PayPal",
  "paymentMethod.zippay.label": "Zip",
  "paymentMethod.zipPay.minCartAmount": "De minimale bestelwaarde om Zip te gebruiken is $35",
  "paymentMethod.zipPay.additionalCharges": "Er kan een extra handelaarsvergoeding van {amount} van toepassing zijn om Zip te gebruiken",
  "paymentMethod.creditCard.label": "Credit Card",
  "paymentMethod.googlePay.label": "Google Pay",
  "paymentMethod.applePay.label": "Apple Pay",
  "inputField.label.country": "Land",
  "inputField.label.zipcode": "Postcode",
  "inputField.label.addressLine": "Adresregel 1",
  "inputField.label.addressLineTwo": "Adresregel 2 (Optioneel)",
  "inputField.label.city": "Stad",
  "inputField.label.state": "Staat",
  "inputField.placeholder.zipCode": "Postcode",
  "inputField.placeholder.addressLine": "Adresregel 1",
  "inputField.placeholder.addressLineTwo": "Adresregel 2 (Optioneel)",
  "inputField.placeholder.city": "Stad",
  "inputField.placeholder.state": "Staat",
  "inputField.errorMessage.cardTypeNotSupported": "Kaarttype wordt niet ondersteund",
  "inputField.errorMessage.invalidCardNumber": "Gelieve een geldig kaart nummer in te voeren",
  "inputField.label.cardNumber": "Kaartnummer",
  "inputField.label.cardExpiry": "Vervaldatum (MM/YY)"
};
exports.default = _default;